import script from "./DragDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DragDialog.vue?vue&type=script&setup=true&lang=js"

import "./DragDialog.vue?vue&type=style&index=0&id=7738b320&lang=scss"
import "./DragDialog.vue?vue&type=style&index=1&id=7738b320&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7738b320"]])

export default __exports__